"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DropdownContext = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var DropdownContext = /*#__PURE__*/(0, _react.createContext)({
  onSelect: function onSelect() {},
  selectedKey: undefined,
  setOpen: function setOpen() {},
  open: false,
  emptyHint: '',
  containerRef: undefined,
  hasItemHighlightedByArrow: false,
  setHasItemHighlightedByArrow: function setHasItemHighlightedByArrow() {}
});
exports.DropdownContext = DropdownContext;

var DropdownProvider = function DropdownProvider(_ref) {
  var children = _ref.children,
      onSelect = _ref.onSelect,
      selectedKey = _ref.selectedKey,
      open = _ref.open,
      emptyHint = _ref.emptyHint,
      triggerRef = _ref.triggerRef,
      containerRef = _ref.containerRef,
      highlightedItemKey = _ref.highlightedItemKey,
      setHighlightedItemKey = _ref.setHighlightedItemKey,
      hasItemHighlightedByArrow = _ref.hasItemHighlightedByArrow,
      setHasItemHighlightedByArrow = _ref.setHasItemHighlightedByArrow;
  (0, _react.useEffect)(function () {
    if (!open) {
      setHighlightedItemKey();
    }
  }, [open, setHighlightedItemKey]);
  return (0, _jsxRuntime.jsx)(DropdownContext.Provider, {
    value: {
      onSelect: onSelect,
      selectedKey: selectedKey,
      open: open,
      emptyHint: emptyHint,
      highlightedItemKey: highlightedItemKey,
      setHighlightedItemKey: setHighlightedItemKey,
      triggerRef: triggerRef,
      containerRef: containerRef,
      hasItemHighlightedByArrow: hasItemHighlightedByArrow,
      setHasItemHighlightedByArrow: setHasItemHighlightedByArrow
    },
    children: children
  });
};

DropdownProvider.propTypes = {
  children: _propTypes.node.isRequired,
  onSelect: _propTypes.func,
  selectedKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  open: _propTypes.bool,
  emptyHint: _propTypes.string,
  triggerRef: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: (0, _propTypes.instanceOf)(Element)
  })]),
  containerRef: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
    current: (0, _propTypes.instanceOf)(Element)
  })]),
  highlightedItemKey: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  setHighlightedItemKey: _propTypes.func,
  hasItemHighlightedByArrow: _propTypes.bool,
  setHasItemHighlightedByArrow: _propTypes.func
};
DropdownProvider.defaultProps = {
  onSelect: function onSelect() {},
  selectedKey: undefined,
  open: false,
  emptyHint: 'No items',
  triggerRef: undefined,
  containerRef: undefined,
  highlightedItemKey: undefined,
  setHighlightedItemKey: function setHighlightedItemKey() {},
  hasItemHighlightedByArrow: false,
  setHasItemHighlightedByArrow: function setHasItemHighlightedByArrow() {}
};
var _default = DropdownProvider;
exports["default"] = _default;
//# sourceMappingURL=Dropdown.provider.js.map